import { useRuntimeConfig } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export const useAuthorizeIntercomUsers = () => {
  const { market } = useMarketplace()
  const { FF_INTERCOM_USER_ACCESS_BY_COUNTRY } = useRuntimeConfig().public

  const { user } = useUserStore()

  function checkAuthorizedIntercomUsers() {
    const countryRules: Record<string, string> = {}

    for (const allowedUsers of FF_INTERCOM_USER_ACCESS_BY_COUNTRY.split(';')) {
      const [country, users] = allowedUsers.split(':')

      if (country && users) {
        countryRules[country.trim().toUpperCase()] = users.trim()
      }
    }

    const userListForCountry = countryRules[market.countryCode]

    if (!userListForCountry) {
      return false
    }

    if (userListForCountry === 'all') return true

    if (userListForCountry === user.value.clientId?.toString()) return true

    const isUserInList = userListForCountry
      .split(',')
      .map((id) => id.trim())
      .includes(user.value.clientId?.toString() ?? '')

    if (isUserInList) return true

    return false
  }

  return { checkAuthorizedIntercomUsers }
}
